export default {
    //cdn储存地址
    cdn:'http://cdn.moocono.com/',
    //后端ip地址
    // ip: '',
    ip: 'http://www.moocono.com/',
    // ip: 'http://home.5windy.com:8000/',
    //登录后跳转的页面 默认为首页
    login_page: '/home',
    //是否显示返回上一级
    is_return: false,
    //登录设备 默认为PC
    is_PC: true,
    //是否为微信打开
    is_wechat: false,
    //是否为IOS
    is_ios:false,
    //首页弹窗
    centerDialogVisible: false,
    //模态框类型
    modalStatus: "",
    //滚轮状态
    scrollType: false,
    //是否登录
    is_login: false,
    //用户资料页面当前选择菜单 userPage.vue
    user_nav_active: '成长记录',
    //登录用户资料 index.vue
    login_user: '',
    //学员弹窗显示 babyModal.vue
    babyModalVisible: false,
    //学员弹窗表单 babyModal.vue
    babyModalForm: '',
    //报名弹窗
    courseEnterVisible: false,
    //学校资料
    schoolInformation: '',
    //搜索字段
    SearchVal: '',
    //floatbar底部active状态页面
    floatBarActive: '',
}


// WEBPACK FOOTER //
// ./src/store/state.js